import { render, staticRenderFns } from "./AddEditTopic.vue?vue&type=template&id=2bee527c"
import script from "./AddEditTopic.vue?vue&type=script&lang=js"
export * from "./AddEditTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports